/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Maple_Crow_FadeInputs */

const en_lean_maple_crow_fade = /** @type {(inputs: Lean_Maple_Crow_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default group`)
};

const de_lean_maple_crow_fade = /** @type {(inputs: Lean_Maple_Crow_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardgruppe`)
};

/**
* | output |
* | --- |
* | "Default group" |
*
* @param {Lean_Maple_Crow_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_maple_crow_fade = /** @type {((inputs?: Lean_Maple_Crow_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Maple_Crow_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_maple_crow_fade(inputs)
	return de_lean_maple_crow_fade(inputs)
});